<!--P057、P058-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">采购调价处理</div>
    </div>
    <!--查询栏-->
    <div class="cs_margin_top div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">供应商</div>
      <search-select :options="search.supplierSearchItems"
                     @option-key="updateSupplier"
                     v-model="search.supplierName"
                     :search-fn="acquireSupplierItem"
                     class="cs_input cs_radius_lg edtxt_info_search width_280"></search-select>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">生效时间</div>
      <div v-show="search.isEffect" class="cs_radius_lg txt_info_search width_240">{{search.effectTime}}</div>
      <input v-show="!search.isEffect" v-model="search.effectTime" id="effectTime" class="cs_input cs_radius_lg edtxt_info_search width_240" placeholder="请输入" readonly>
      <div class="div_cbtn cs_margin_left_sm cs_margin_top_xs">
        <span class="icon_cbtn" :class="{'on':search.isEffect}"></span>
        <input value="true" class="txt_cbtn" :checked='search.isEffect' @click="check1" type="checkbox">立即生效
      </div>
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">备注</div>
      <input v-model="search.hint" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm width_670 ui_margin_left_30" placeholder="请输入">
    </div>
    <!--表格-->
    <div class="cs_margin_top div_search_result cs_padding_top">
      <div class="div_search">
        <div class="cs_title_primary cs_text_default type_info_search">调价货品</div>
        <search-select :options="search.materialSearchItems"
                       @option-key="updateMaterialName"
                       v-model="search.materialName"
                       :search-fn="acquireMaterialItem"
                       class="cs_input cs_radius_lg edtxt_info_search width_280"></search-select>
        <button class="ui_btn_search_yellow btn_search_table cs_margin_left" type="button" @click="btnSearch">查询</button>
      </div>
      <div class="cs_margin_top_sm div_table">
        <table class="cs_table cs_td_divider_none cs_thead_fixed" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="151px">货品编号</th>
            <th width="280px">货品名称</th>
            <th width="100px">规格</th>
            <th width="130px">采购单位</th>
            <th width="184px">当前采购价</th>
            <th width="184px">调后采购价</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList" :key="index" :class="{table_active:activeTr===index || item.isSelected}" :id="'anchor'+index" @click="btnSelectTableTr(item)">
            <td width="40px">{{index+1}}</td>
            <td width="151px">{{item.materialNum}}</td>
            <td width="280px">{{item.materialName}}</td>
            <td width="100px">{{item.materialSpecs}}</td>
            <td width="130px">{{item.units}}</td>
            <td width="184px">{{item.unitPrice}}</td>
            <td width="184px"><input v-model="item.newPrice" class="edtxt_table" @keyup="inputLimitPositiveFloat($event)" @blur="$set(orderList[index], 'newPrice', formatPositiveFloat($event))"></td>
          </tr>
          <template v-if="PAGE_SIZE>orderList.length">
            <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
              <td width="40px"></td>
              <td width="151px"></td>
              <td width="280px"></td>
              <td width="100px"></td>
              <td width="130px"></td>
              <td width="184px"></td>
              <td width="184px"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      <div class="cs_text_sm cs_text_primary cs_margin_top_xs txt_hint_table">制单时间：{{getNowDate()}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;制单人：{{userName}}</div>
      <div class="div_operation_table">
        <button @click="btnConfirm" class="cs_btn_dialog ui_btn_blue cs_fr"
                type="button">确认调价
        </button>
      </div>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select";
  import StorageConst from "../../assets/utils/StorageConst";
  export default {
    name: "PurchasePriceHandle",
    components: {SearchSelect, WebSelect},
    data: function () {
      return {
        search: {
          supplierId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.PURCHASE_PRICE_HANDLE,"supplierId", ""),
          supplierName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.PURCHASE_PRICE_HANDLE,"supplierName", ""),
          supplierSearchItems: [],
          hint: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.PURCHASE_PRICE_HANDLE,"hint", ""),
          materialSearchItems: [],
          materialId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.PURCHASE_PRICE_HANDLE,"materialId", ""),
          materialName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.PURCHASE_PRICE_HANDLE,"materialName", ""),
          effectTime: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.PURCHASE_PRICE_HANDLE,"effectTime", this.getNextHour()),
          isEffectList: [],
          isEffect: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.PURCHASE_PRICE_HANDLE,"isEffect", false),
        },
        orderList: [],
        selectedList:[],
        activeTr: "",
        userName:"",
        PAGE_SIZE: 10,
      }
    },
    created: function () {
      this.userName = this.isEmpty(this.$cookies.get(StorageConst.COOKIE_STAFF_NAME))?"":this.$cookies.get(StorageConst.COOKIE_STAFF_NAME);
      if(!this.isEmpty(this.search.supplierId)){
        this.showList();
      }
    },
    mounted: function () {
      const that = this;
      laydate.render({
        elem: '#effectTime',
        btns:["now","confirm"],
        type: "datetime",
        format: "yyyy-MM-dd HH时",
        done(value) {
          that.search.effectTime = value;
        },
      });
    },
    methods:{
      showList() {
        this.$ajax.common.listMaterialBySupplier.bind(this)(this.search.supplierId, (data) => {
          let list = data.data;
          list.forEach((item) => {
            item.newPrice = "";
            item.isSelected = false;
          });
          this.orderList = list;
        }, (data) => {
        }, true)
      },
      btnSearch(){
        if(!this.isEmpty(this.search.materialId)){
          this.orderList.some((item, i)=>{
            if(item.materialId===this.search.materialId){
              this.activeTr = i;
              document.getElementById('anchor'+i).scrollIntoView();
              return true
            }
          });
        }else {
          this.activeTr = "";
        }
      },
      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.orderList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
      },
      btnConfirm(){
        this.selectedList = [];
        if(this.isEmpty(this.search.supplierId)){
          this.$toast("请选择供应商");
          return
        }
        this.orderList.forEach((item) => {
          if(!this.isEmpty(item.newPrice)){
            let selectItem = {
              materialId: item.materialId,
              newPrice: item.newPrice
            };
            this.selectedList.push(selectItem);
          }
        });
        if(this.selectedList.length<1){
          this.$toast("请选择调价货品");
          return
        }
        //判断生效时间
        if(!this.search.isEffect && this.isEmpty(this.search.effectTime)){
          this.$toast("请选择生效时间");
          return
        }
        let time = this.search.isEffect?"立即生效":this.search.effectTime;
        this.$alert("本次发生调价货品共"+this.selectedList.length+" 种<br>生效时间："+time+"<br>确认进行调价吗？", (clickConfirm) => {
          if (clickConfirm) {
            let effectTimeSubmit = this.isEmpty(this.search.effectTime)?"":this.search.effectTime.substring(0,13);
            this.$ajax.priceManage.addPurchasePriceManage.bind(this)(this.search.supplierId,this.search.hint,JSON.stringify(this.selectedList),this.search.isEffect,effectTimeSubmit, (data) => {
              this.$toast("调价成功");
              this.selectedList = [];
              this.showList();
            }, (data) => {
            }, true)
          }
        }, true);
      },

      failDefault() {

      },
      acquireSupplierItem(search) {
        this.$ajax.common.searchSupplier.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].supplierNum+"  "+data.data[i].supplierName,
            })
          }
          this.search.supplierSearchItems = array;
        }, this.failDefault, false);
      },
      updateSupplier(key) {
        this.search.supplierId = key;
        this.orderList = [];
        this.selectedList = [];
        if(!this.isEmptySelect(key)){
          this.showList();
        }else {
          this.search.supplierName = "";
        }
      },
      acquireMaterialItem(search) {
        this.$ajax.common.searchMaterial.bind(this)(search,(data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
            })
          }
          this.search.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialName(key) {
        this.search.materialId = key;
        if(this.isEmpty(key)){
          this.search.materialName = "";
        }
      },
      check1() {
        this.search.isEffect = !this.search.isEffect;
      },
      timeToDate(time){
        return this.isEmpty(time)?"":time.substring(0,10)
      },
    }
  }
</script>

<style scoped>
  .width_670{width: 670px;}
  .width_280{width: 280px;}
  .txt_hint_table{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
  }
  .btn_search_table {
    position: relative;
    display: inline-block;
    width: 110px;
    height: 38px;
    font-size: 14px;
    padding-left: 48px;
    line-height: 38px;
    text-align: left;
  }
  .edtxt_table{
    width: 80px;
    height: 26px;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    font-size: 12px;
    color: #333333;
    line-height: 26px;
    text-align: center;
  }
  .table_active td{
    background: rgba(255,181,76,0.1);
  }
  .cs_table tbody{max-height: 410px;}
  .div_cbtn{
    display: inline-block;
    position: relative;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    color: #333333;
  }
  .txt_cbtn {
    display: inline-block;
    position: absolute;
    opacity: 0;
    width: 22px;
    height: 22px;
    cursor: pointer;
    left: 0;
    outline: none;
    -webkit-appearance: none;
  }
  .icon_cbtn {
    display: inline-block;
    vertical-align: top;
    width: 22px;
    height: 22px;
    cursor: pointer;
    background: url(../../assets/image/icon_cbtn.png) no-repeat center;
    background-size: 16px 16px;
  }
  .on {
    background: url(../../assets/image/icon_cbtn_checked.png) no-repeat center;
    background-size: 16px 16px;
  }
</style>



// WEBPACK FOOTER //
// src/page/price/PurchasePriceHandle.vue